// Port of api/fuel/app/classes/insights/worth/ratings.php

import Segment from 'offline/insights/segment'
import Constants from 'offline/constants'
import Util from 'offline/util'

function featuredGame(raw) {
	var games = raw ? raw.split(',').map(function(id) { return parseInt(id, 10) }).filter(Boolean) : []
	return games.length ? games.sort(function(a, b) { return a - b })[0] : 0
}

export default Segment.extend({
	name: 'ratings',
	types: [Constants.TYPE_USER],
	insight: false,
	detail: ['ratings'],
	run: function(type, owner, userIndex, detail, filter, vars) {
		var band = parseInt(vars.band, 10) || 0
		var mode = (filter && filter.ratings) ? filter.ratings : 'total'

		if (detail) {
			var games = []
			var detailRaw = Util.queryFast(
				'SELECT g.game_id AS g, COALESCE(NULLIF(v.game_version_worth_value, 0), g.game_worth_value, 0) AS w' +
				' FROM (collection c JOIN game g ON c.game_id = g.game_id)' +
				' LEFT JOIN game_version v ON v.game_version_id = c.game_version_id' +
				' WHERE c.user_id = ' + owner.get_id() +
				' AND c.collection_own = 1' +
				' AND c.collection_rating >= ' + band +
				' AND c.collection_rating < ' + (band + 1) +
				' AND g.game_worth_value > 0' +
				' AND c.collection_expansion = 0' +
				' ORDER BY w DESC'
			)

			for (var i = 0; i < detailRaw.length; i++) {
				var gameId = parseInt(detailRaw[i].g, 10)
				this._references.games.push(gameId)
				games.push({
					id: gameId,
					worth: Math.round(parseFloat(detailRaw[i].w) || 0)
				})
			}

			return {
				games: games
			}
		}

		var ratings = []
		var raw = Util.queryFast(
			'SELECT GROUP_CONCAT(DISTINCT(c.game_id)) AS i, FLOOR(c.collection_rating) AS r,' +
			' COUNT(DISTINCT(c.game_id)) AS g,' +
			' ' + (mode === 'total' ? 'SUM' : 'AVG') + '(COALESCE(NULLIF(v.game_version_worth_value, 0), g.game_worth_value, 0)) AS w' +
			' FROM (collection c JOIN game g ON c.game_id = g.game_id)' +
			' LEFT JOIN game_version v ON v.game_version_id = c.game_version_id' +
			' WHERE c.user_id = ' + owner.get_id() +
			' AND c.collection_own = 1' +
			' AND c.collection_rating > 0' +
			' AND g.game_worth_value > 0' +
			' AND c.collection_expansion = 0' +
			' GROUP BY FLOOR(c.collection_rating) ORDER BY FLOOR(c.collection_rating)'
		)

		for (var j = 0; j < raw.length; j++) {
			var item = raw[j]
			var worth = parseFloat(item.w) || 0
			if (!worth) continue
			ratings.push({
				r: parseInt(item.r, 10) || 0,
				w: Math.round(worth * 100) / 100,
				g: parseInt(item.g, 10) || 0,
				f: featuredGame(item.i)
			})
		}

		return {
			ratings: ratings
		}
	}
})
